/**
 * 用于请求增强的工具
 * @date 2022/3/21 
 * @author xmetaki(lgz) 
 * @copyright jyht
 */

/**
 * 
 * @param {Promise} promise request服务
 * @param {String} placeHolder 占位提示信息 
 * @returns 
 */
export function promiseWrapper(promise, placeHolder='') {
    if (!promise instanceof Promise) return Promise.reject('参数应为Promise实例引用')
    console.log(`[info] 正在执行${placeHolder}请求`)
    return promise.then(res => {
        if (res?.result == '0' || res === true) return res;
        throw new Error('接口连通性正常 返回数据异常')
    }).catch(err => {
        console.error(`[Error] PromiseWrapper请求异常\n详细错误信息: ${placeHolder}${err.message || err.stack}`)
        return {}
    })
}